<div class="creative-people-area bg_image--50 ptb--200 ptb-md--80 ptb-sm--80">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="creative-people-inner text-center">
                    <h2 class="heading">Expansión del Ser</h2>
                    <h2 style="margin-top: 20px;"><span class="theme-color"
                            style="font-size: xx-large; background-color: antiquewhite; padding: 5px 15px;"> PROGRAMA DE
                            21 DÍAS</span></h2>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Info del curso -->
<div class="bk-number-speaks section-ptb-xl bg_image--3">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12">
                <div class="number-speaks">
                    <div class="content wow move-up">
                        <h3 style="font-size: 20px; color: rgb(255, 255, 255);"><span
                                style="background-color: rgb(69, 29, 163); padding: 5px 10px;">MASTERCLASS</span></h3>
                        <h2>NeuroAkashico® <br> <span class="secondary-color" style="font-size: 30px;">Combustible y
                                alimento para nuestras células</span></h2>
                        <div style="margin-top:15px;"> <img src="assets/img/neuroakashico.png" alt="Brook Preloader">
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12 mt_md--40 mt_sm--40">
                <div class="speakers-number-wrap">

                    <div class="tab">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home"
                                    role="tab" aria-controls="pills-home" aria-selected="true">Costo</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile"
                                    role="tab" aria-controls="pills-profile" aria-selected="false"
                                    style="background: #491d6b; color: white; margin-left: 10px;">
                                    Temario</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="pills-detalles-tab" data-toggle="pill" href="#pills-detalles"
                                    role="tab" aria-controls="pills-detalles" aria-selected="false"
                                    style="background: #f39302; color: white; margin-left: 10px;">
                                    Incluye</a>
                            </li>

                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                aria-labelledby="pills-home-tab">
                                <app-p21esclase></app-p21esclase>
                                
                            </div>
                            <div class="tab-pane fade" id="pills-profile" role="tabpanel"
                                aria-labelledby="pills-profile-tab">
                                <div style="margin-top: 20px">
                                   
                                    <ul style="list-style: decimal;">
                                        <li style="padding-top: 10px;">Cierre y apertura de nuevos Ciclos</li>
                                        <li style="padding-top: 10px;">El principio del Dar: principios de Luz</li>
                                        <li style="padding-top: 10px;">Integración del Observador</li>
                                        <li style="padding-top: 10px;">Tu Relación con el Dinero</li>
                                        <li style="padding-top: 10px;">Tu relación con el Amor y Relación de Pareja</li>
                                        <li style="padding-top: 10px;">Tu relación con el Tiempo</li>
                                        <li style="padding-top: 10px;">Tu relación con la Abundancia</li>
                                        <li style="padding-top: 10px;">Integración del entendimiento del GRAN Observador y Conciencia de Unidad.</li>
                                        <li style="padding-top: 10px;">Se un emprendedor, negociador y/o facilitador
                                            efectivo</li>
                                        <li style="padding-top: 10px;">Se un emprendedor, negociador y/o facilitador efectivo.</li>
                                    </ul>
                                    <p style="background-color: #520699; color: white; padding: 10px 20px;">Construye, personaliza y programa tu agenda.</p>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-detalles" role="tabpanel"
                                aria-labelledby="pills-detalles-tab">

                                <ul>
                                    <li>Acompañamiento y contención personalizada</li>
                                    <li style="padding-top: 10px;">21 audios por WhatsApp</li>
                                    <li style="padding-top: 10px;">21 Temas</li>
                                    <li style="padding-top: 10px;">Manual Guía PDF</li>
                                    <li style="padding-top: 10px;">Videos</li>
                                </ul>
                            </div>

                        </div>
                    </div>




                </div>
            </div>
        </div>
    </div>
</div>

<app-beneficios></app-beneficios>